// extracted by mini-css-extract-plugin
module.exports = {"row":"Items_row__7Vrir","item":"Items_item__JCWhJ","title":"Items_title__j1Bx3","image":"Items_image__wDukA"};